<script setup lang="ts">
import Spinner from '@/components/BaseSpinner.vue'
import { RouterView } from 'vue-router'
import BaseToast from './components/BaseToast.vue'
</script>

<template>
  <div class="h-dvh w-dvw text-gray-900">
    <BaseToast />
    <!-- Main RouterView -->
    <RouterView v-slot="{ Component }">
      <template v-if="Component">
        <Suspense>
          <!-- main content -->
          <component :is="Component"></component>
          <!-- loading state -->
          <template #fallback>
            <div class="flex h-full w-full items-center justify-center">
              <Spinner class="h-10 w-10"></Spinner>
            </div>
          </template>
        </Suspense>
      </template>
    </RouterView>
  </div>
</template>
